import axios from 'axios'
import React from 'react'

import { useEffect,useRef } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'



import {HiEllipsisHorizontal} from 'react-icons/hi2'

import { FaShare,FaComment} from 'react-icons/fa'
import { FcLike } from 'react-icons/fc'

import profile from '../img/untitled.png'
import post1 from '../img/post1.jpg'
import post3 from '../img/post3.png'
import ad1 from '../img/adCheckout1.jpg'
import ad2 from '../img/adCheckout2.jpg'
import ad3 from '../img/adCheckout3.jpg'
import { AiOutlineHeart, AiOutlineRetweet } from 'react-icons/ai'
import MyModal from './PostModal'
import CreatePostImg from './CreatePostImg'
import CreateQuotePost from './CreateQuotePost'
import CreateLinkPost from './CreateLinkPost'
import CreateHiChatPost from './CreateHiChatPost'
import CreateAudioPost from './CreateAudioPost'
import CreateVidPost from './CreateVidPost'
import { IoIosArrowDropdownCircle } from 'react-icons/io'





export default function Explore() {
 const [adPopup,setAdpopUp1] =useState(false);
const [showTooltip,setShowTooltip]=useState(false)
const [showCommentTooltip,setShowCommentTooltip] =useState(false)

const [showReblogTooltip, setShowReblogTooltip] = useState(false);
const [showLikeTooltip, setShowLikeTooltip] = useState(false);
const [commentSectionShow, setCommentSectionShow] = useState(false);
const [reblogSectionShow, setReblogSectionShow] = useState(false);
const [likedBySectionShow, setLikedBySectionShow] = useState(false);
const profileStickyRef =useRef(null);
const postRef =useRef(null);
const [like,setLike]=useState(false)
const toggleCommentArea = () => {
  setCommentSectionShow((current) => !current);

};

const handleLike=()=>{
  setLike(current=>!current)
}

const toggleReblogArea = () => {
  setReblogSectionShow((current) => !current);

};

useEffect(()=>{
  const handleScroll=()=>{
    const {bottom}=postRef.current.getBoundingClientRect()
    if (bottom<=0) {
      profileStickyRef.current.classList.remove('sticky')
    }
    else{
      profileStickyRef.current.classList.add('sticky')
    }
  }
  window.addEventListener('scroll',handleScroll)
  return()=>{
    window.removeEventListener('scroll',handleScroll)
  }
},[])




 
  return (
    <>
     




<div className="container-fluid">
     
    <div className="row  justify-content-center ">
    <div className="col-lg-6 col-sm-12 col-md-12">
    <main className='mt-5 pt-5 header'>




    <section className=" d-flex text-center justify-content-center col-lg-12 postArea mt-4">
              <Link className=" me-2  d-lg-block col-sm-1 " ref={profileStickyRef}  >
                <img src={profile} alt="" className="rounded-2 profilePic  sticky" style={{width:"4rem"}} />
              </Link>

              <div className="post sticky bg-white rounded-1 p-1 pe-1 col-lg-10 col-sm-12 " ref={postRef}>
                <header
                  className=" text-start ms-1 fw-bold pb-2"
                  style={{ color: "rgb(0, 207, 53)" }}
                >
                  <div className="border-bottom border-1">Recommended</div>
                  <div className="d-flex postOptions">
                    <Link className="username fw-bold text-dark text-decoration-none  mt-3" style={{fontSize:"0.9rem"}}>
                      tiktoksthataregood-ish
                    </Link>
                    <Link className="text-decoration-none ms-2 fs-6 mt-3">
                      Follow
                    </Link>
                    <button className="btn border-0 ms-auto fw-bolder fs-2">
                      <HiEllipsisHorizontal />
                    </button>
                  </div>
                </header>

                <main><Link>
                <img src={post3} alt="" className="img-fluid" />
                </Link>
            
                </main>
                <div
                  className="tags text-dark container"
                  style={{ color: "gray" }}
                >
                  <Link> #video</Link>
                  <Link> #tiktok</Link>
                  <Link> #video</Link>
                </div>

                <footer className=" tags container d-flex mb-2 mt-4 ">
                  <div>
                    <Link className="fs-6"> 1412 notes</Link>
                  </div>
                  <aside className=" ms-auto">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Share</Tooltip>}
                      show={showTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() => setShowTooltip(!showTooltip)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <FaShare />
                      </Link>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">comment</Tooltip>}
                      show={showCommentTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() =>
                          setShowCommentTooltip(!showCommentTooltip)
                        }
                        onMouseLeave={() => setShowCommentTooltip(false)}
                        onClick={toggleCommentArea}
                      >
                        <FaComment />
                      </Link>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Reblog</Tooltip>}
                      show={showReblogTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() =>
                          setShowReblogTooltip(!showReblogTooltip)
                        }
                        onMouseLeave={() => setShowReblogTooltip(false)}
                      >
                        <AiOutlineRetweet />
                      </Link>
                    </OverlayTrigger>

                    
                    {like===true?(
                     
                        <Link
                        className={like?'  p-1 fs-4 liked':''}
                        onMouseEnter={() =>
                          setShowLikeTooltip(!showLikeTooltip)
                        }
                        onMouseLeave={() => setShowLikeTooltip(false)}
                        onClick={handleLike}
                      >

                        <FcLike/>
                      </Link>
                    
                        ):(
                          <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Like</Tooltip>}
                      show={showLikeTooltip}
                    >
                      <Link 
                        className="p-1 fs-4  "
                        onMouseEnter={() =>
                          setShowLikeTooltip(!showLikeTooltip)
                        }
                        onMouseLeave={() => setShowLikeTooltip(false)}
                        onClick={handleLike}
                      >

                        <AiOutlineHeart />
                      </Link>

                      
                      
                    </OverlayTrigger>
                        )}
                  </aside>
                </footer>
                <section className="">

                  {commentSectionShow && (
                    <>
                      <aside
                        className=" ms-auto border-bottom border-top p-1 text-start  commentArea position-sticky"
                        style={{ width: "95%" }}
                      >
                        <Link className="p-1 fs-4" style={{color:commentSectionShow===true?"green":" rgb(112, 106, 106)"}}>
                          <FaComment /> <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4"  onClick={()=>{
                          toggleReblogArea()
                         setCommentSectionShow(false)
                         
                        }}>
                          <AiOutlineRetweet />{" "}
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4">
                          <AiOutlineHeart />
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>
                      </aside>
                      <div className="row mt-3 ">
                        <div className="userProfileComment col-lg-2 ">
                          <img
                            className="rounded-circle"
                            src={profile}
                            alt=""
                            style={{ width: "2.5rem" }}
                          />
                        </div>
                        <div className="addComment col-lg-10  col-sm-10 col-md-10">
                          <input
                            type="text "
                            className="form-control rounded-pill comment"
                            placeholder="Unleash a compliment                                            Reply"
                          />
                        </div>
                      </div>

                      <main className="mt-3 loadedcommentsArea">
                        <div className="row ">
                          <div className="userProfileComment col-lg-2 col-sm-3 col-md-2">
                            <img
                              className="rounded-circle"
                              src={profile}
                              alt=""
                              style={{ width: "2rem" }}
                            />
                            
                          </div>

                          
                          <div className=" col-lg-9 col-sm-5 col-md-6 mb-1 ">
                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>
</div>
</div>

<div className="row ">
                          <div className="userProfileComment col-lg-2 col-sm-2 col-md-2">
                            <img
                              className="rounded-circle"
                              src={profile}
                              alt=""
                              style={{ width: "2rem" }}
                            />
                            
                          </div>

                          
                          <div className=" col-lg-9 col-sm-10 col-md-10 mb-1 ">
                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>
</div>
</div>
                            {/* <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>

                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>

                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p> */}
                        
                        
                      </main>
                    </>
                  )}

                  {reblogSectionShow && (
                    <>
                      <aside
                        className=" ms-auto border-bottom border-top p-1 text-start  commentArea position-sticky"
                        style={{ width: "95%" }}
                      >
                        <Link className="p-1 fs-4"
                        onClick={()=>{
                          setCommentSectionShow(true)
                          setReblogSectionShow(false)
                        }}
                        >
                          <FaComment /> <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4" style={{color:reblogSectionShow===true?"green":" rgb(112, 106, 106)"}} >
                          <AiOutlineRetweet />{" "}
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4">
                          <AiOutlineHeart />
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>
                      </aside>

                      <main className="mt-3 loadedcommentsArea">
                        <ul>
                 
                        <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>




                          
                        </ul>
                      </main>
                    </>
                  )}
                </section>
              </div>


            </section>

            <section className=" d-flex text-center justify-content-center col-lg-12 postArea mt-4">
              <Link className=" me-2  d-lg-block col-sm-1 " ref={profileStickyRef}  >
                <img src={profile} alt="" className="rounded-2 profilePic  sticky" style={{width:"4rem"}} />
              </Link>

              <div className="post sticky bg-white rounded-1 p-1 pe-1 col-lg-10 col-sm-12 " ref={postRef}>
                <header
                  className=" text-start ms-1 fw-bold pb-2"
                  style={{ color: "rgb(0, 207, 53)" }}
                >
                  <div className="border-bottom border-1">Recommended</div>
                  <div className="d-flex postOptions">
                    <Link className="username fw-bold text-dark text-decoration-none  mt-3" style={{fontSize:"0.9rem"}}>
                      tiktoksthataregood-ish
                    </Link>
                    <Link className="text-decoration-none ms-2 fs-6 mt-3 follow">
                      Follow
                    </Link>
                    <button className="btn border-0 ms-auto fw-bolder fs-2">
                      <HiEllipsisHorizontal />
                    </button>
                  </div>
                </header>

                <main><Link>
                <img src={post3} alt="" className="img-fluid" />
                </Link>
            
                </main>
                <div
                  className="tags text-dark container"
                  style={{ color: "gray" }}
                >
                  <Link> #video</Link>
                  <Link> #tiktok</Link>
                  <Link> #video</Link>
                </div>

                <footer className=" tags container d-flex mb-2 mt-4 ">
                  <div>
                    <Link className="fs-6"> 1412 notes</Link>
                  </div>
                  <aside className=" ms-auto">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Share</Tooltip>}
                      show={showTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() => setShowTooltip(!showTooltip)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <FaShare />
                      </Link>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">comment</Tooltip>}
                      show={showCommentTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() =>
                          setShowCommentTooltip(!showCommentTooltip)
                        }
                        onMouseLeave={() => setShowCommentTooltip(false)}
                        onClick={toggleCommentArea}
                      >
                        <FaComment />
                      </Link>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Reblog</Tooltip>}
                      show={showReblogTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() =>
                          setShowReblogTooltip(!showReblogTooltip)
                        }
                        onMouseLeave={() => setShowReblogTooltip(false)}
                      >
                        <AiOutlineRetweet />
                      </Link>
                    </OverlayTrigger>

                    
                    {like===true?(
                     
                        <Link
                        className={like?'  p-1 fs-4 liked':''}
                        onMouseEnter={() =>
                          setShowLikeTooltip(!showLikeTooltip)
                        }
                        onMouseLeave={() => setShowLikeTooltip(false)}
                        onClick={handleLike}
                      >

                        <FcLike/>
                      </Link>
                    
                        ):(
                          <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Like</Tooltip>}
                      show={showLikeTooltip}
                    >
                      <Link 
                        className="p-1 fs-4  "
                        onMouseEnter={() =>
                          setShowLikeTooltip(!showLikeTooltip)
                        }
                        onMouseLeave={() => setShowLikeTooltip(false)}
                        onClick={handleLike}
                      >

                        <AiOutlineHeart />
                      </Link>

                      
                      
                    </OverlayTrigger>
                        )}
                  </aside>
                </footer>
                <section className="">

                  {commentSectionShow && (
                    <>
                      <aside
                        className=" ms-auto border-bottom border-top p-1 text-start  commentArea position-sticky"
                        style={{ width: "95%" }}
                      >
                        <Link className="p-1 fs-4" style={{color:commentSectionShow===true?"green":" rgb(112, 106, 106)"}}>
                          <FaComment /> <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4"  onClick={()=>{
                          toggleReblogArea()
                         setCommentSectionShow(false)
                         
                        }}>
                          <AiOutlineRetweet />{" "}
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4">
                          <AiOutlineHeart />
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>
                      </aside>
                      <div className="row mt-3 ">
                        <div className="userProfileComment col-lg-2 ">
                          <img
                            className="rounded-circle"
                            src={profile}
                            alt=""
                            style={{ width: "2.5rem" }}
                          />
                        </div>
                        <div className="addComment col-lg-10  col-sm-10 col-md-10">
                          <input
                            type="text "
                            className="form-control rounded-pill comment"
                            placeholder="Unleash a compliment                                            Reply"
                          />
                        </div>
                      </div>

                      <main className="mt-3 loadedcommentsArea">
                        <div className="row ">
                          <div className="userProfileComment col-lg-2 col-sm-3 col-md-2">
                            <img
                              className="rounded-circle"
                              src={profile}
                              alt=""
                              style={{ width: "2rem" }}
                            />
                            
                          </div>

                          
                          <div className=" col-lg-9 col-sm-5 col-md-6 mb-1 ">
                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>
</div>
</div>

<div className="row ">
                          <div className="userProfileComment col-lg-2 col-sm-2 col-md-2">
                            <img
                              className="rounded-circle"
                              src={profile}
                              alt=""
                              style={{ width: "2rem" }}
                            />
                            
                          </div>

                          
                          <div className=" col-lg-9 col-sm-10 col-md-10 mb-1 ">
                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>
</div>
</div>
                            {/* <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>

                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>

                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p> */}
                        
                        
                      </main>
                    </>
                  )}

                  {reblogSectionShow && (
                    <>
                      <aside
                        className=" ms-auto border-bottom border-top p-1 text-start  commentArea position-sticky"
                        style={{ width: "95%" }}
                      >
                        <Link className="p-1 fs-4"
                        onClick={()=>{
                          setCommentSectionShow(true)
                          setReblogSectionShow(false)
                        }}
                        >
                          <FaComment /> <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4" style={{color:reblogSectionShow===true?"green":" rgb(112, 106, 106)"}} >
                          <AiOutlineRetweet />{" "}
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4">
                          <AiOutlineHeart />
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>
                      </aside>

                      <main className="mt-3 loadedcommentsArea">
                        <ul>
                 
                        <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>




                          
                        </ul>
                      </main>
                    </>
                  )}
                </section>
              </div>


            </section>


            <section className=" d-flex text-center justify-content-center col-lg-12 postArea mt-4">
              <Link className=" me-2  d-lg-block col-sm-1 " ref={profileStickyRef}  >
                <img src={profile} alt="" className="rounded-2 profilePic  sticky" style={{width:"4rem"}} />
              </Link>

              <div className="post sticky bg-white rounded-1 p-1 pe-1 col-lg-10 col-sm-12 " ref={postRef}>
                <header
                  className=" text-start ms-1 fw-bold pb-2"
                  style={{ color: "rgb(0, 207, 53)" }}
                >
                  <div className="border-bottom border-1">Recommended</div>
                  <div className="d-flex postOptions">
                    <Link className="username fw-bold text-dark text-decoration-none  mt-3" style={{fontSize:"0.9rem"}}>
                      tiktoksthataregood-ish
                    </Link>
                    <Link className="text-decoration-none ms-2 fs-6 mt-3">
                      Follow
                    </Link>
                    <button className="btn border-0 ms-auto fw-bolder fs-2">
                      <HiEllipsisHorizontal />
                    </button>
                  </div>
                </header>

                <main><Link>
                <img src={post3} alt="" className="img-fluid" />
                </Link>
            
                </main>
                <div
                  className="tags text-dark container"
                  style={{ color: "gray" }}
                >
                  <Link> #video</Link>
                  <Link> #tiktok</Link>
                  <Link> #video</Link>
                </div>

                <footer className=" tags container d-flex mb-2 mt-4 ">
                  <div>
                    <Link className="fs-6"> 1412 notes</Link>
                  </div>
                  <aside className=" ms-auto">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Share</Tooltip>}
                      show={showTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() => setShowTooltip(!showTooltip)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <FaShare />
                      </Link>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">comment</Tooltip>}
                      show={showCommentTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() =>
                          setShowCommentTooltip(!showCommentTooltip)
                        }
                        onMouseLeave={() => setShowCommentTooltip(false)}
                        onClick={toggleCommentArea}
                      >
                        <FaComment />
                      </Link>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Reblog</Tooltip>}
                      show={showReblogTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() =>
                          setShowReblogTooltip(!showReblogTooltip)
                        }
                        onMouseLeave={() => setShowReblogTooltip(false)}
                      >
                        <AiOutlineRetweet />
                      </Link>
                    </OverlayTrigger>

                    
                    {like===true?(
                     
                        <Link
                        className={like?'  p-1 fs-4 liked':''}
                        onMouseEnter={() =>
                          setShowLikeTooltip(!showLikeTooltip)
                        }
                        onMouseLeave={() => setShowLikeTooltip(false)}
                        onClick={handleLike}
                      >

                        <FcLike/>
                      </Link>
                    
                        ):(
                          <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Like</Tooltip>}
                      show={showLikeTooltip}
                    >
                      <Link 
                        className="p-1 fs-4  "
                        onMouseEnter={() =>
                          setShowLikeTooltip(!showLikeTooltip)
                        }
                        onMouseLeave={() => setShowLikeTooltip(false)}
                        onClick={handleLike}
                      >

                        <AiOutlineHeart />
                      </Link>

                      
                      
                    </OverlayTrigger>
                        )}
                  </aside>
                </footer>
                <section className="">

                  {commentSectionShow && (
                    <>
                      <aside
                        className=" ms-auto border-bottom border-top p-1 text-start  commentArea position-sticky"
                        style={{ width: "95%" }}
                      >
                        <Link className="p-1 fs-4" style={{color:commentSectionShow===true?"green":" rgb(112, 106, 106)"}}>
                          <FaComment /> <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4"  onClick={()=>{
                          toggleReblogArea()
                         setCommentSectionShow(false)
                         
                        }}>
                          <AiOutlineRetweet />{" "}
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4">
                          <AiOutlineHeart />
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>
                      </aside>
                      <div className="row mt-3 ">
                        <div className="userProfileComment col-lg-2 ">
                          <img
                            className="rounded-circle"
                            src={profile}
                            alt=""
                            style={{ width: "2.5rem" }}
                          />
                        </div>
                        <div className="addComment col-lg-10  col-sm-10 col-md-10">
                          <input
                            type="text "
                            className="form-control rounded-pill comment"
                            placeholder="Unleash a compliment                                            Reply"
                          />
                        </div>
                      </div>

                      <main className="mt-3 loadedcommentsArea">
                        <div className="row ">
                          <div className="userProfileComment col-lg-2 col-sm-3 col-md-2">
                            <img
                              className="rounded-circle"
                              src={profile}
                              alt=""
                              style={{ width: "2rem" }}
                            />
                            
                          </div>

                          
                          <div className=" col-lg-9 col-sm-5 col-md-6 mb-1 ">
                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>
</div>
</div>

<div className="row ">
                          <div className="userProfileComment col-lg-2 col-sm-2 col-md-2">
                            <img
                              className="rounded-circle"
                              src={profile}
                              alt=""
                              style={{ width: "2rem" }}
                            />
                            
                          </div>

                          
                          <div className=" col-lg-9 col-sm-10 col-md-10 mb-1 ">
                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>
</div>
</div>
                            {/* <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>

                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>

                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p> */}
                        
                        
                      </main>
                    </>
                  )}

                  {reblogSectionShow && (
                    <>
                      <aside
                        className=" ms-auto border-bottom border-top p-1 text-start  commentArea position-sticky"
                        style={{ width: "95%" }}
                      >
                        <Link className="p-1 fs-4"
                        onClick={()=>{
                          setCommentSectionShow(true)
                          setReblogSectionShow(false)
                        }}
                        >
                          <FaComment /> <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4" style={{color:reblogSectionShow===true?"green":" rgb(112, 106, 106)"}} >
                          <AiOutlineRetweet />{" "}
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4">
                          <AiOutlineHeart />
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>
                      </aside>

                      <main className="mt-3 loadedcommentsArea">
                        <ul>
                 
                        <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>




                          
                        </ul>
                      </main>
                    </>
                  )}
                </section>
              </div>


            </section>



              <section className=" d-flex text-center justify-content-center col-lg-12 postArea mt-4">
              <Link className=" me-2  d-lg-block col-sm-1 " ref={profileStickyRef}  >
                <img src={profile} alt="" className="rounded-2 profilePic  sticky" style={{width:"4rem"}} />
              </Link>

              <div className="post sticky bg-white rounded-1 p-1 pe-1 col-lg-10 col-sm-12 " ref={postRef}>
                <header
                  className=" text-start ms-1 fw-bold pb-2"
                  style={{ color: "rgb(0, 207, 53)" }}
                >
                  <div className="border-bottom border-1">Recommended</div>
                  <div className="d-flex postOptions">
                    <Link className="username fw-bold text-dark text-decoration-none  mt-3" style={{fontSize:"0.9rem"}}>
                      tiktoksthataregood-ish
                    </Link>
                    <Link className="text-decoration-none ms-2 fs-6 mt-3">
                      Follow
                    </Link>
                    <button className="btn border-0 ms-auto fw-bolder fs-2">
                      <HiEllipsisHorizontal />
                    </button>
                  </div>
                </header>

                <main><Link>
                <img src={post3} alt="" className="img-fluid" />
                </Link>
            
                </main>
                <div
                  className="tags text-dark container"
                  style={{ color: "gray" }}
                >
                  <Link> #video</Link>
                  <Link> #tiktok</Link>
                  <Link> #video</Link>
                </div>

                <footer className=" tags container d-flex mb-2 mt-4 ">
                  <div>
                    <Link className="fs-6"> 1412 notes</Link>
                  </div>
                  <aside className=" ms-auto">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Share</Tooltip>}
                      show={showTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() => setShowTooltip(!showTooltip)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <FaShare />
                      </Link>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">comment</Tooltip>}
                      show={showCommentTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() =>
                          setShowCommentTooltip(!showCommentTooltip)
                        }
                        onMouseLeave={() => setShowCommentTooltip(false)}
                        onClick={toggleCommentArea}
                      >
                        <FaComment />
                      </Link>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Reblog</Tooltip>}
                      show={showReblogTooltip}
                    >
                      <Link
                        className="p-1 fs-4"
                        onMouseEnter={() =>
                          setShowReblogTooltip(!showReblogTooltip)
                        }
                        onMouseLeave={() => setShowReblogTooltip(false)}
                      >
                        <AiOutlineRetweet />
                      </Link>
                    </OverlayTrigger>

                    
                    {like===true?(
                     
                        <Link
                        className={like?'  p-1 fs-4 liked':''}
                        onMouseEnter={() =>
                          setShowLikeTooltip(!showLikeTooltip)
                        }
                        onMouseLeave={() => setShowLikeTooltip(false)}
                        onClick={handleLike}
                      >

                        <FcLike/>
                      </Link>
                    
                        ):(
                          <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="">Like</Tooltip>}
                      show={showLikeTooltip}
                    >
                      <Link 
                        className="p-1 fs-4  "
                        onMouseEnter={() =>
                          setShowLikeTooltip(!showLikeTooltip)
                        }
                        onMouseLeave={() => setShowLikeTooltip(false)}
                        onClick={handleLike}
                      >

                        <AiOutlineHeart />
                      </Link>

                      
                      
                    </OverlayTrigger>
                        )}
                  </aside>
                </footer>
                <section className="">

                  {commentSectionShow && (
                    <>
                      <aside
                        className=" ms-auto border-bottom border-top p-1 text-start  commentArea position-sticky"
                        style={{ width: "95%" }}
                      >
                        <Link className="p-1 fs-4" style={{color:commentSectionShow===true?"green":" rgb(112, 106, 106)"}}>
                          <FaComment /> <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4"  onClick={()=>{
                          toggleReblogArea()
                         setCommentSectionShow(false)
                         
                        }}>
                          <AiOutlineRetweet />{" "}
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4">
                          <AiOutlineHeart />
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>
                      </aside>
                      <div className="row mt-3 ">
                        <div className="userProfileComment col-lg-2 ">
                          <img
                            className="rounded-circle"
                            src={profile}
                            alt=""
                            style={{ width: "2.5rem" }}
                          />
                        </div>
                        <div className="addComment col-lg-10  col-sm-10 col-md-10">
                          <input
                            type="text "
                            className="form-control rounded-pill comment"
                            placeholder="Unleash a compliment                                            Reply"
                          />
                        </div>
                      </div>

                      <main className="mt-3 loadedcommentsArea">
                        <div className="row ">
                          <div className="userProfileComment col-lg-2 col-sm-3 col-md-2">
                            <img
                              className="rounded-circle"
                              src={profile}
                              alt=""
                              style={{ width: "2rem" }}
                            />
                            
                          </div>

                          
                          <div className=" col-lg-9 col-sm-5 col-md-6 mb-1 ">
                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>
</div>
</div>

<div className="row ">
                          <div className="userProfileComment col-lg-2 col-sm-2 col-md-2">
                            <img
                              className="rounded-circle"
                              src={profile}
                              alt=""
                              style={{ width: "2rem" }}
                            />
                            
                          </div>

                          
                          <div className=" col-lg-9 col-sm-10 col-md-10 mb-1 ">
                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>
</div>
</div>
                            {/* <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>

                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p>

                            <p className="loadedComments mt-2">
                              <span className="fw-bolder mb-1"> user</span>
                              <br />
                              whose been there since the international commute
                              of the whales
                            </p> */}
                        
                        
                      </main>
                    </>
                  )}

                  {reblogSectionShow && (
                    <>
                      <aside
                        className=" ms-auto border-bottom border-top p-1 text-start  commentArea position-sticky"
                        style={{ width: "95%" }}
                      >
                        <Link className="p-1 fs-4"
                        onClick={()=>{
                          setCommentSectionShow(true)
                          setReblogSectionShow(false)
                        }}
                        >
                          <FaComment /> <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4" style={{color:reblogSectionShow===true?"green":" rgb(112, 106, 106)"}} >
                          <AiOutlineRetweet />{" "}
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>

                        <Link className="p-1 fs-4">
                          <AiOutlineHeart />
                          <span className="fs-6"> 1,000</span>{" "}
                        </Link>
                      </aside>

                      <main className="mt-3 loadedcommentsArea">
                        <ul>
                 
                        <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>

                          <li className="border-top ">
                          <div className="d-flex">
                          <Link className="" >
                              <img className="rounded-circle" src={profile} alt="" style={{ width: "1.5rem" }} />
                            </Link>
                            <Link
                              className="fw-bold text-decoration-none text-dark ms-2"
                              style={{ fontSize: "0.9rem" }}
                            >
                              username
                            </Link> <p className="ms-1"> <AiOutlineRetweet/></p> 
                          </div>
                           
                            <p className="tags fs-6">
                            #music #violin
                            </p>
                            
                        
<br />
<div className="text-start text-light " style={{fontSize:"0.8rem",color:"grey"}}>
<Link className="text-decoration-none text-dark">
  Reblog
</Link>

<Link className="text-decoration-none text-dark ms-2">
  View post
</Link>
</div>

                            <div>
                              <p>...</p>
                            </div>
                          </li>




                          
                        </ul>
                      </main>
                    </>
                  )}
                </section>
              </div>


            </section>

</main>
  </div>



  <div className="col-lg-3 col-sm-12 text-start rounded-3  " >
  <header className='checkoutAd    text-light mt-5 pt-5'>
    <p className='fs-5 fw-bolder'>Check out these blogs</p>
  </header>

  <aside className='ad mt-2 p-2' style={{background:"rgba(255,255,255,0.07)"}}>
    <ul>
      <li className=''>
      <Link className=' d-flex justify-content-between '>

     
      <div>
      <Link className='text-decoration-none'>
      <div className='text-light'>
        <img src={ad1} alt=""  className='rounded-2 float-start me-3'/>
 anxiety problem <br />
 <p className='  '> Anxiety Problem</p> 
        </div>
      </Link>
      </div>

        <div>
        <Link className='text-decoration-none'> Follow</Link>
        </div>
        <div>
        <Link className='text-decoration-none fw-bold' style={{color:"grey"}}> x</Link>
        </div>

        </Link>

        
      </li>

      <li className=''>
      <Link className='hoverAd d-flex justify-content-between '>

     
      <div>
      <Link className='text-decoration-none'>
      <div className='text-light'>
        <img src={ad1} alt=""  className='rounded-2 float-start me-3'/>
 anxiety problem <br />
 <p className='fw-bolder '> Anxiety Problem</p> 
        </div>
      </Link>
      </div>

        <div>
        <Link className='text-decoration-none'> Follow</Link>
        </div>
        <div>
        <Link className='text-decoration-none fw-bold' style={{color:"grey"}}> x</Link>
        </div>

        </Link>

        
      </li>


      <li className=''>
      <Link className='hoverAd d-flex justify-content-between '>

     
      <div>
      <Link className='text-decoration-none'>
      <div className='text-light'>
        <img src={ad1} alt=""  className='rounded-2 float-start me-3'/>
 anxiety problem <br />
 <p className='fw-bolder '> Anxiety Problem</p> 
        </div>
      </Link>
      </div>

        <div>
        <Link className='text-decoration-none'> Follow</Link>
        </div>
        <div>
        <Link className='text-decoration-none fw-bold' style={{color:"grey"}}> x</Link>
        </div>

        </Link>

        
      </li>


      <li className=''>
      <Link className='hoverAd d-flex justify-content-between '>

     
      <div>
      <Link className='text-decoration-none'>
      <div className='text-light'>
        <img src={ad1} alt=""  className='rounded-2 float-start me-3'/>
 anxiety problem <br />
 <p className='fw-bolder '> Anxiety Problem</p> 
        </div>
      </Link>
      </div>

        <div>
        <Link className='text-decoration-none'> Follow</Link>
        </div>
        <div>
        <Link className='text-decoration-none fw-bold' style={{color:"grey"}}> x</Link>
        </div>

        </Link>

        
      </li>


    </ul>
    
    
  </aside>
  


</div>
    </div>

</div>




  
  


    
 



    </>
  )
}
